import type { RouteObject } from 'react-router-dom';

import { Scopes } from '../../api/types';
import { ErrorBoundary } from '../../components/ErrorBoundary';
import { RouteGuard } from '../../components/RouteGuard';
import { DocumentReviewerPage } from './pages/DocumentReviewerPage';

/** Routes contributed by the Document Reviewer feature (Phase 5 Wave 3). */
export const reviewerRoutes: RouteObject[] = [
  {
    path: 'documents/:id',
    element: (
      <RouteGuard scope={Scopes.DocumentsRead}>
        <ErrorBoundary name="Reviewer">
          <DocumentReviewerPage />
        </ErrorBoundary>
      </RouteGuard>
    ),
  },
];
